import {ButtonType} from '../Button/types'
import {EanCheckProps} from './types'
import {ICheckEanResponse} from '../../Services/Campaign/interfaces'
import {StatusCode} from '../../Services/Response.types'
import {useTranslation} from 'react-i18next'
import Alert from '../Alert'
import Button from '../Button'
import CampaignService from '../../Services/Campaign'
import InputSearch from '../InputSearch'
import React, {useState, ChangeEvent} from 'react'
import { renderSingleImage } from '@apps/Shared/Utils'
import './Scss/ean-check.scss';

const eanCheckImageSizes = ['(min-width: 250px) 15.625rem', '100vw'];

const EanCheck = (props: EanCheckProps) => {
    const {t} = useTranslation();
    const [loading, setLoading] = useState<boolean>(false);
    const [ean, setEan] = useState<string>('');
    const [requestErrors, setRequestErrors] = useState<string[]>([]);
    const [result, setResult] = useState<ICheckEanResponse | undefined>(
        undefined
    );

    const [hasChangedSinceSubmit, setHasChangedSinceSubmit] = useState<boolean>(
        true
    );
    const [showResult, setShowResult] = useState<boolean>(false);

    const showRequestErrors =
        !result &&
        !hasChangedSinceSubmit &&
        requestErrors &&
        requestErrors.length > 0;
    const disableSubmit = (loading || !hasChangedSinceSubmit);

    const onChangeEan = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value
        setEan(value);
        setHasChangedSinceSubmit(true);
        setShowResult(false);
    }

    const onTestEan = () => {
        setLoading(true)
        let response: ICheckEanResponse = {}
        CampaignService.CheckEan(ean || '-')
            .then(result => {
                if (result.status === StatusCode.OK) {
                    response = result.data
                    if (!response) {
                        return;
                    }
                    setResult(response);
                    setShowResult(true);
                    setRequestErrors([]);
                } else if (result.status === StatusCode.NO_CONTENT) {
                    setResult({
                        active: false,
                        depositCode: '',
                        description: '',
                        material: '',
                        ean: ean,
                    });
                    setShowResult(true);
                } else {
                    setResult(response);
                }
                setHasChangedSinceSubmit(false);
                setLoading(false);
            })
            .catch(error => {
                console.log(error);
                setLoading(false);
            });
    }

    return (
        <div className='ean-check'>
            <>
                {props.image?.path && (
                    renderSingleImage({
                        url: props.image.path,
                        altText: props.image.altText || props.heading || '',
                        sizes: eanCheckImageSizes,
                    })
                )}
                <h2>{props.heading}</h2>
                <span>{t('campaign.eancheckInfo')}</span>
                <div className="ean-check__search">
                    <InputSearch
                        id="ean-input"
                        inputSearchClassName={"ean-check"}
                        iconClassName={"ean-check__search-icon"}
                        className={"ean-check__input-text-wrapper"}
                        label=""
                        autoComplete="off"
                        value={ean}
                        maxLength={20}
                        onChange={onChangeEan}
                        placeholder={t('campaign.eanPlaceholder')}
                    />
                </div>
                <Button
                    type={ButtonType.PRIMARY}
                    text={t('campaign.testean')}
                    onClick={onTestEan}
                    loading={loading}
                    disabled={disableSubmit}
                    large={true}
                />
                {showResult && result && (
                    <div className="ean-check__result">
                        {result.active ? (
                            <div>
                                <div className="card">
                                    <div className="card__header primary">
                                        <span className="card__header-text">{t('campaign.eanStatusActive')}</span>
                                        <span className="icon-thumb_up panicon"></span>
                                    </div>
                                    <div className="card__content">
                                        <span className="ean-check__result-row">
                                            <strong>{t('campaign.ean')}:</strong>
                                            <span>{result?.ean}</span>
                                        </span>
                                        <span className="ean-check__result-row">
                                            <strong>{t('campaign.info')}:</strong>
                                            <span>{result?.description}</span>
                                        </span>
                                        <span className="ean-check__result-row">
                                            <strong>{t('campaign.material')}:</strong>
                                            <span>{result?.material}</span>
                                        </span>
                                        <span className="ean-check__result-row">
                                            <strong>{t('campaign.deposit')}:</strong>
                                            <span>{result?.depositCode}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="card">
                                <div className="card__header danger">
                                    <span className="card__header-text">{t('campaign.eanStatusInactive')}</span>
                                    <span className="icon-thumb_down panicon"></span>
                                </div>
                                <div className="card__content">
                                    <h5>{t('campaign.errorWhy')}</h5>
                                    <ul>
                                        {(
                                            (t('campaign.eanErrorReasons', {
                                                returnObjects: true,
                                            }) as string[]) || []
                                        ).map(reason => (
                                            <li key={reason}>
                                                {reason}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        )}
                    </div>
                )}
                {showRequestErrors && (
                    <div className="ean-check__error">
                        <Alert
                            type="danger"
                            text={t('error.somethingWrong')}
                            subtext={requestErrors}
                            compact={false}
                        />
                    </div>
                )}
            </>
        </div>
    )
}

export default EanCheck
